import { render, staticRenderFns } from "./NextUpView.vue?vue&type=template&id=8c7f8894&scoped=true"
import script from "./NextUpView.vue?vue&type=script&lang=js"
export * from "./NextUpView.vue?vue&type=script&lang=js"
import style0 from "./NextUpView.vue?vue&type=style&index=0&id=8c7f8894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7f8894",
  null
  
)

export default component.exports